<template>
  <div class="VTable__wrap">
    <div class="shadow main" ref="main">
      <el-table
        ref="multipleTable"
        :key="tableKey"
        v-loading="loading"
        highlight-current-row
        :default-expand-all="defaultExpandAll"
        row-key="id"
        :element-loading-text="loadingText"
        :data="data"
        :height="height"
        :max-height="maxHeight"
        :header-cell-style="{ background: '#30C3B1', color: '#fff' }"
        :cell-style="cellStyle"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="showSelect"
          type="selection"
          align="center"
          width="55"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column type="index" :label="indexLabel" width="80">
        </el-table-column>
        <el-table-column
          v-for="item in field"
          :key="item.name"
          :prop="item.name"
          :label="item.label"
          :width="item.width ? item.width : ''"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.showTooltip"
        >
          <template slot-scope="{ row, $index }">
            <slot :name="item.name" :row="row" :$index="$index">{{
              row[item.name]
            }}</slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination__wrap" v-if="hasPagionation">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "VTable",
  props: {
    title: { required: false, type: String, default: "" },
    addText: { required: false, type: String, default: "新增" },
    lazy: { required: false, type: Boolean, default: false },
    hasPagionation: { required: false, type: Boolean, default: false },
    showOverflowTooltip: { required: false, type: Boolean, default: true },
    exportText: { required: false, type: String, default: "导出" },
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: "加载中" },
    auth: { required: false, type: Array, default: () => [] },
    field: { required: false, type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    page: { required: false, type: Number, default: 1 },
    pageSize: { required: false, type: Number, default: 10 },
    total: { required: false, type: Number, default: 0 },
    defaultExpandAll: { require: false, type: Boolean, default: false },
    showSelect: { required: false, type: Boolean, default: false },
    indexLabel: { required: false, type: String, default: "序号" },
    selectable: { required: false, type: Function, default: () => false },
    cellStyle: { required: false, type: Function, default: null },
    tableKey: { required: false, type: [String, Number], default: "" },
    maxHeight: {
      required: false,
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      // 传了 maxHeight 就直接用 null（走 el-table max-height），避免初始 500 导致布局错乱
      height: this.maxHeight != null ? null : 500,
      resizeHandler: null,
    };
  },
  methods: {
    handleSizeChange(pageSize) {
      this.$emit("handleSizeChange", pageSize);
    },
    handleCurrentChange(page) {
      this.$emit("handleCurrentChange", page);
    },
    // 批量选择
    handleSelectionChange(batchData) {
      this.$emit("handleSelectionChange", batchData);
    },
    resetTableHeight() {
      // 传了 maxHeight 就跳过自动计算，让 el-table 用 max-height 约束
      if (this.maxHeight !== null && this.maxHeight !== undefined) {
        this.height = null;
        return;
      }
      const table = this.$refs.multipleTable ? this.$refs.multipleTable.$el : '';
      if (table) {
        // 用 getBoundingClientRect 拿表格到视口顶部的真实距离（比 offsetParent 链准）
        const rect = this.$refs.multipleTable.$el.getBoundingClientRect();
        const h = window.innerHeight - rect.top - 70;
        this.height = h > 200 ? h : 500;
      }
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   console.log(`main的高度：${this.$refs.main.offsetHeight}`);
    //   this.height = this.$refs.main.offsetHeight || 500;
    // });
    this.$nextTick(() => {
      this.resetTableHeight();
    });
    this.resizeHandler = () => {
      this.$nextTick(() => {
        this.resetTableHeight();
      });
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
    this.resizeHandler = null;
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          this.resetTableHeight();
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.doLayout();
          }
        });
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.VTable__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .main {
    flex: 1;
    margin-bottom: 15px;
  }
  .pagination__wrap {
    text-align: right;
    padding: 0 50px;
  }
}
</style>
